"use client";

import NextError from "next/error";
import { useEffect } from "react";

import { describeErrorForOps, reportOpsError } from "@/lib/ops-log";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  console.error(error);

  // Report the root-layout crash to ops. In an effect, not at render time, so a
  // re-render (or React's development double-render) cannot double-count it.
  // `digest` is a server-side hash of the error, not its text — safe to forward,
  // and it is the only handle that ties this event back to a server log line.
  // Sliced because the field is typed as a plain string: nothing guarantees a
  // short hash, and `reportOpsEvent`'s cap would otherwise be what saves us.
  useEffect(() => {
    const described = describeErrorForOps(error);
    reportOpsError(
      "APP_CRASH",
      error.digest ? `${described} (digest ${error.digest.slice(0, 64)})` : described,
    );
  }, [error]);

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}